<template>
  <div class="container">
    <div class="info bg-fff">
      <div class="topInfo pl5 pr5">
        <!-- <p class="mb10 mt10">审核医生：{{info.optRealName}}</p> -->
        <p class="font-16 mb10">审核时间：{{info.optTime}}</p>
      </div>
      <div class="list" v-for="(item,index) in info.list" :key="index">
        <van-divider>{{item.elementClassName}}</van-divider>
        <!-- <p class="itemTitle font-16 bold">{{item.elementClassName}}</p> -->
        <div class="" v-for="(item2,index2) in item.list" :key="index2">
          <p class="secondLevelTitle">{{item2.elementName}}</p>
          <ul class="pl20">
            <!-- resultType 1数值；2文本；3文件 -->
            <li class="flexCenter mt10" v-if="item2.resultType == 1">检查结果：{{item2.resultContent}}<span class="color-red ml5">{{item2.positiveSymbol.indexOf('H') >-1?'↑':item2.positiveSymbol.indexOf('L') >-1?'↓':item2.positiveSymbol.indexOf('A') >-1?'!':''}}</span></li>
            <li class="flexCenter mt10" v-if="item2.resultType == 2">检查结果：{{item2.resultContent}}<span class="color-red ml5">{{item2.positiveSymbol.indexOf('H') >-1?'↑':item2.positiveSymbol.indexOf('L') >-1?'↓':item2.positiveSymbol.indexOf('A') >-1?'!':''}}</span></li>
            <li class="flexCenter mt10" v-if="item2.resultType == 3">检查结果：<span @click="fileDownload(item2.resultContent)">查看</span>
            </li>
            <li class="mt10">单位：{{item2.unit}}</li>
            <li class="mt10">异常描述：<span class="color-red">{{item2.positiveValue}}</span></li>
            <li class="mt10">正常参考值：{{item2.referenceShow}}</li>
            <li class="mt10 mb10">建议：{{item2.suggestion}}</li>
          </ul>
        </div>
      </div>
    </div>
    <v-goTop :top="scroll_top" @func="getMsgFormSon"></v-goTop>
  </div>
</template>
<script>
  import GoTop from "@/components/GoTop";
  import { Button,Toast,Divider  } from "vant";
  export default {
  name: 'ReportDetail',
  components: {
    [Button.name]: Button,
    [Toast.name]: Toast,
    [Divider.name]: Divider,
    'v-goTop': GoTop,
  },
  data() {
    return {
      id:'',
      scroll_top: '',
      msgFormSon: '',
      info: {}
    }
  },
  watch: {
    
  },
  created() {
    if(this.$route.query && this.$route.query.id){
      this.id = this.$route.query.id;
    };
    this.getInfo();
  },
  methods: {
    getInfo(){
       $.ajax({
        url: this.GLOBAL.url + '/wx/viewReport',
        type: 'get',
        xhrFields: {
          withCredentials: true
        },
        crossDomain: true,
        data: {
          auditId:this.id
        },
        success: (res) => {
          if (res.code == 200) {
            this.info = res.data;
          } else {
            Toast(res.msg)
          };
        },
        error: (e) => {
          console.log(e);
        }
      })
    },
    getMsgFormSon(data) {
      var self = this;
      self.msgFormSon = data;
      let timer = null;
      cancelAnimationFrame(timer);
      timer = requestAnimationFrame(function fn() {
        if (self.msgFormSon > 0) {
          self.msgFormSon -= 50;
          $('#roll').scrollTop(self.msgFormSon)
          timer = requestAnimationFrame(fn);
        } else {
          cancelAnimationFrame(timer);
        }
      });
    },
    fileDownload(filename){
      if(filename){
        $.ajax({
          url: this.GLOBAL.aliyunOssUrl + '/getAccessUrl',
          type: 'get',
          xhrFields: {
            withCredentials: true
          },
          data: {
           bucketName:'izcare1',
           objectName:filename
          },
          crossDomain: true,
          success: (res) => {
            if (res.code == 200) {
              window.top.location.href= res.data.url;
            } else {
              this.$toast(res.msg)
            };
          
          },
          error: (e) => {
            console.log(e);
          }
        })
      }else{
        Toast('文件名不可为空！');
      }
    },
  },
  computed: {

  },
}</script>
<style type="text/css" scoped>
.container {
  width: 100%;
  height: 100%;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
}

.info {
  width: 95%;
  margin: 0.266667rem auto;
  border: 0.026667rem solid #e0e0e0; /* Lighter grey border */
  border-radius: 0.4rem; /* Slightly increased border-radius */
  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.05); /* Softer shadow */
}

.itemTitle {
  padding: 0.266667rem 0;
}

.secondLevelTitle {
  padding: 0.266667rem;
  background-color: rgba(240, 248, 255, 0.8); /* Softer blue */
}
</style>